import * as React from "react";
function ButtonGhostIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    x: 1,
    y: 1,
    fillOpacity: 0.4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14.333h4.167l.75 1.834h1.75L12.208 7h-1.25L7 16.167h1.75l.75-1.834zm2.083-5.683l1.559 4.183h-3.117l1.558-4.183z"
  }));
}
const ForwardRef = React.forwardRef(ButtonGhostIcon);
export default ForwardRef;